<template>
<div class="exam-result">
  <ucar-title>{{examInfo.title}}</ucar-title>
  <div class="pane">
    <h4>得分:{{examInfo.score}}分</h4>
    <h1 class="fail" v-if="examInfo.passFlag == 0">很遗憾，考试未通过！</h1>
    <h1 class="success" v-if="examInfo.passFlag == 1">恭喜，考试通过！</h1>
  </div>
  <h4 class="title-divider" v-show="errorExam.length">错题集</h4>
  <div class="question-box" v-show="errorExam.length">
    <question-item v-for="(item,index) in errorExam"
                   :key="index"
                   :subjectNo="index + 1"
                   :title="item.subjectDesc"
                   :options="item.optionList"
                   :points="item.score"
                   :subjectType="item.optionType"></question-item>
  </div>
  <div class="button-bar">
    <span class="button" @click="back">返回课程详情</span>
  </div>
</div>
</template>

<script>
import QuestionItem from '../../components/question-item'

export default {
  data () {
    return {
      examInfo: {},
      errorExam: [],
      title: '测试结果'
    }
  },
  components: { 
    QuestionItem
  },
  methods: {
    back () {
      this.$router.replace(`/lesson-detail/${this.vuexTrainExamResult.courseId}`)
    }
  },
  mounted () {
    // 如果为空，则返回相关页面 仅刷新时会有这种情况
    if (!this.vuexTrainExamResult) {
      this.back()
      return
    }
    this.examInfo = this.vuexTrainExamResult.examInfo
    this.errorExam = this.vuexTrainExamResult.errorExam
  }
}
</script>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';

.exam-result {
  .pane {
    padding: 50px 0;
    background-color: #fff;
    text-align: center;
    h1 {
      margin-bottom: 0;
    }
    .fail {
      color: $ucar_label_color;
    }
    .success {
      color: $ucar_main_color;
    }
  }
  .title-divider {
    text-align: center;
    line-height: 100px;
    margin-bottom: 0;
  }
  .question-box {
    padding: 0 30px;
    flex: 1 0 auto;
  }
  .button-bar {
    box-sizing: border-box;
    background-color: $ucar_main_bg;
    padding: 30px 15px;
    .button {
      font-size: $ucar_font_h3;
      display: block;
      text-align: center;
      height: 90px;
      line-height: 90px;
      color: #fff;
      border-radius: 10px;
      background-color: $ucar_main_color;
    }
  }
}
</style>

